var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.Renewal },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function() {
                      _vm.list = []
                      _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("refresh")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addCode.open("add")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("generateGiftCode")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _vm.list.length
            ? _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.exportLoading },
                      on: { click: _vm.exportListdata }
                    },
                    [_vm._v(_vm._s(_vm.$t("export")))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.list, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "gen_id",
              label: _vm.$t("idLabel"),
              "min-width": "60"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "code_type",
              label: _vm.$t("type"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "gen_num",
              label: _vm.$t("quantity"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reward_num",
              label: _vm.$t("claimableCount"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("prizeDetails"), "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "viewText",
                        on: {
                          click: function($event) {
                            return _vm.viewCloose(scope.row.reward_str)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("view")) + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "",
              label: _vm.$t("isSpecialGiftPack"),
              "min-width": "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.is_special == 0
                            ? _vm.$t("no")
                            : _vm.$t("yes")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "",
              label: _vm.$t("generateTime"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(" " + _vm._s(scope.row.gen_time) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "end_time",
              label: _vm.$t("startTime"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.extra_param !== "{}"
                            ? JSON.parse(scope.row.extra_param).reg_begintime
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "end_time",
              label: _vm.$t("endTime"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.extra_param !== "{}"
                            ? JSON.parse(scope.row.extra_param).reg_endtime
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "dead_times",
              label: _vm.$t("expireTime"),
              "min-width": "180"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "passwd_secret",
              label: _vm.$t("isDeleted"),
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.is_del == 1 ? _vm.$t("deleted") : _vm.$t("normal")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "200",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.modifyCode.open(scope.row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("edit")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.viewCode(scope.row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("viewGiftCode")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(scope.row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addCode", {
        ref: "addCode",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } },
        on: { update: _vm.getList }
      }),
      _c("articles", { ref: "articles" }),
      _c("other", { ref: "other" }),
      _c("modifyCode", {
        ref: "modifyCode",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } },
        on: { update: _vm.getList }
      }),
      _c("userInfoDetail", { ref: "userInfoDetail" }),
      _c(
        "el-drawer",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.isPrize },
          on: {
            "update:visible": function($event) {
              _vm.isPrize = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "20px" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.prizeList, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "item_id", label: _vm.$t("nameLabel") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.articleList.findIndex(function(item) {
                                      return item.id == row.item_id
                                    }) > -1
                                      ? _vm.articleList[
                                          _vm.articleList.findIndex(function(
                                            item
                                          ) {
                                            return item.id == row.item_id
                                          })
                                        ].kind
                                      : row.item_id
                                  ) +
                                  " "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: _vm.$t("quantity") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "expire", label: _vm.$t("time") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(row.expire || _vm.$t("unlimited")) +
                                  " "
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.isCode },
          on: {
            "update:visible": function($event) {
              _vm.isCode = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "codeListsTop" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportdata } },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { padding: "40px 20px 0", position: "relative" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.codeLists, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "code_body", label: _vm.$t("giftCodeBody") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "gen_id", label: _vm.$t("operationId") }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "draw_nums", label: _vm.$t("claimedCount") }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "draw_nums",
                      label: _vm.$t("serverIdRoleName"),
                      width: "150px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.draw_nums == 1
                              ? _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.usage_info[0] &&
                                          row.usage_info[0].server_id +
                                            "-" +
                                            row.usage_info[0].role_name
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            row.draw_nums > 1
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "viewText",
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.userInfoDetail.open(
                                            row
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("usedUser")) + " "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total,
          "page-size": 10
        },
        on: { "current-change": _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }